<div class="container-fluid">
  <div class="row mt-3">
    <div class="col">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col text-center">
              <h3 style="margin: 0px;">{{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}</h3>
            </div>
          </div>
          <div class="row mt-2 mb-2">
            <div class="col">
              <div class="row">
                <div class="col text-left">
                  <div class="btn btn-primary btn-sm" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate">
                    Previous
                  </div>
                </div>
                <div class="col text-center">
                  <div class="btn btn-outline-secondary btn-sm" mwlCalendarToday [(viewDate)]="viewDate">
                    Today
                  </div>
                </div>
                <div class="col text-right">
                  <div class="btn btn-primary btn-sm" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate">
                    Next
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <mwl-calendar-month-view [viewDate]="viewDate" [events]="calendarEvents"></mwl-calendar-month-view>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>